export default __webpack_public_path__ + "static/heroSectionBg-aaf08e527ae121ef4ebbc4f09ee55127.png";